module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-33.ab528ced.png";